// import React, { useState, useEffect, useContext } from 'react';
// import { Link, useNavigate, useLocation } from 'react-router-dom';
// import { useAuth } from "../../context/authContext";
// import { CurrencyContext } from "../../context/CurrencyContext";
// import { RiMenuSearchFill } from "react-icons/ri";
// import { RxAvatar } from "react-icons/rx";

// const API = process.env.REACT_APP_API_URL;

// const Header = () => {
//   const {
//     isLoggedIn,
//     isAdmin,
//     handleLogout,
//     user,
//     cart,
//     wishlist,
//     fetchWishlist,
//     fetchCart,
//     products,
//     fetchProducts
//   } = useAuth();

//   const allCategories = ['All', ...new Set(products.map(p => p.category))];

//   const { currency, changeCurrency } = useContext(CurrencyContext);
//   const [cartCount, setCartCount] = useState(0);
//   const [wishlistCount, setWishlistCount] = useState(0);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [showSuggestions, setShowSuggestions] = useState(false);
//   const [suggestions, setSuggestions] = useState([]);
//   const { pathname } = useLocation();
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const navigate = useNavigate();
//   const [drawerOpen, setDrawerOpen] = useState(false);

//   const isActive = (path) => pathname === path;

//   // Search Logic
//   useEffect(() => {
//     if (!searchTerm.trim()) {
//       setSuggestions([]);
//       setShowSuggestions(false);
//       return;
//     }
//     const filtered = products
//       .filter(product =>
//         product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         product.genericName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         product.category.toLowerCase().includes(searchTerm.toLowerCase())
//       )
//       .slice(0, 6);
//     setSuggestions(filtered);
//     setShowSuggestions(true);
//   }, [searchTerm, products]);

//   // Click Outside Logic
//   useEffect(() => {
//     const handleClickOutside = () => setShowSuggestions(false);
//     document.addEventListener('click', handleClickOutside);
//     return () => document.removeEventListener('click', handleClickOutside);
//   }, []);

//   // Badge Logic
//   useEffect(() => {
//     setCartCount(cart?.length || 0);
//     setWishlistCount(wishlist?.length || 0);
//   }, [cart, wishlist]);

//   // Initial Fetch Logic
//   useEffect(() => {
//     if (isLoggedIn) {
//       fetchWishlist();
//       fetchCart();
//       fetchProducts();
//     } else {
//       setCartCount(0);
//       setWishlistCount(0);
//     }
//   }, [isLoggedIn]);

//   const onLogoutClick = () => {
//     handleLogout();
//     setDrawerOpen(false);
//   };
  
//   const goToCategory = (cat) => {
//     navigate(cat === 'All' ? '/' : `/category/${cat.toLowerCase()}`);
//   };

//   const exchangeRates = {
//     INR: 1,
//     USD: 0.012,
//     EUR: 0.011,
//     GBP: 0.0097
//   };

//   const formatPrice = (amount, currency) => {
//     const converted = (amount * (exchangeRates[currency] || 1)).toFixed(2);
//     let symbol = "";
//     switch (currency) {
//       case "USD": symbol = "$"; break;
//       case "EUR": symbol = "€"; break;
//       case "GBP": symbol = "£"; break;
//       case "INR": symbol = "₹"; break;
//       default: symbol = currency + " "; break;
//     }
//     return `${symbol}${converted}`;
//   };

//   return (
//     <>
//       <nav className="bg-black sticky top-0 z-50 shadow-2xl border-b border-red-900/20">
//         <div className="w-full px-4">
//           <div className="container mx-auto flex items-center justify-between h-16 md:h-20">

//             {/* ================= MOBILE HEADER - Full logo like desktop, no overlap ================= */}
// <div className="relative flex items-center justify-between w-full lg:hidden h-16 px-2 sm:px-4">

//   {/* Left: Hamburger - stays near left edge */}
//   <button
//     onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//     className="p-2  rounded-lg bg-red-900/30 transition-all flex items-center justify-center z-20 text-white -ml-6"
//     title="Menu & Search"
//   >
//     <RiMenuSearchFill className="text-3xl sm:text-3xl" />  {/* size adjustable */}
//   </button>

//   {/* Center: Full Logo + Text - centered, but constrained width */}
//   <Link
//     to="/"
//     className="absolute left-1/2 -translate-x-1/2 group relative flex items-center gap-1.5 sm:gap-2 shrink-0 max-w-[60%] sm:max-w-[65%] justify-center z-10 pointer-events-auto mr-14 -ml-5"
//   >
//     <div className="relative flex-shrink-0">
//       <div className="absolute -inset-2 bg-gradient-to-r from-red-600/40 to-pink-600/40 rounded-xl blur-lg opacity-0 group-hover:opacity-100 transition-opacity duration-500 -z-10"></div>
//       <div className="p-1 bg-gradient-to-br from-red-500 to-red-700 rounded-lg shadow-2xl">
//         <div className="p-1 bg-black rounded-md">
//           <img
//             src="/assets/images/logo.png"
//             alt="MediStore"
//             className="h-7 w-auto sm:h-8 drop-shadow-2xl"
//           />
//         </div>
//       </div>
//     </div>

//     <div className="flex flex-col leading-tight min-w-0">
//       <h1 className="text-lg sm:text-xl md:text-2xl font-black tracking-tight whitespace-nowrap">
//         <span className="text-white">Medi</span>
//         <span className="text-red-500">Store</span>
//       </h1>
//       <span className="text-[9px] sm:text-[10px] font-bold text-red-500 tracking-widest -mt-0.5 opacity-90 whitespace-nowrap">
//         ONLINE PHARMACY
//       </span>
//     </div>
//   </Link>

  
//   <div className="flex items-center justify-end z-20 -mr-2 sm:mr-0 ml-1">
//     {!isLoggedIn ? (
//     <Link
//   to="/auth?tab=register"
//   className={`
//     inline-flex items-center justify-center
//     bg-gradient-to-r from-red-600 to-red-700
//     text-white font-bold
//     rounded-lg shadow-md
//     min-w-[96px]               /* prevents ultra-narrow button */
//     px-1 py-2 text-sm         /* base = mobile */
//     sm:px-5 sm:py-3 sm:text-base /* larger screens get more generous */
//     transition-all duration-200
//     hover:brightness-110 active:scale-95
//     touch-manipulation    
//        /* improves touch feel on mobile */
//   `}
// >
//   Sign Up
// </Link>
//   ) : (
//     <button
//   onClick={() => setDrawerOpen(true)}
//   className="       
//     text-white
//     flex items-center justify-center
//     bg-transparent
//     shadow-lg      /* optional subtle glow/border */
//     shrink-0
//     border-none
//     hover:bg-none
//   "
//   title="Account / Profile"
// >
//   <RxAvatar className=" text-white" size={34} />   {/* icon size – text-2xl fits nicely in 36x36 px */}
// </button>
//   )}
//   </div>
// </div>

//             {/* ================= DESKTOP / LARGE HEADER ================= */}
//             <div className="hidden lg:flex items-center justify-between w-full">

//               {/* Logo */}
//               <Link to="/" className="group relative flex items-center gap-2 shrink-0">
//                 <div className="relative">
//                   <div className="absolute -inset-2 bg-gradient-to-r from-red-600/40 to-pink-600/40 rounded-xl blur-lg opacity-0 group-hover:opacity-100 transition-opacity duration-500 -z-10"></div>
//                   <div className="p-1 bg-gradient-to-br from-red-500 to-red-700 rounded-lg sm:rounded-xl shadow-2xl">
//                     <div className="p-1 sm:p-1.5 bg-black rounded-md sm:rounded-lg">
//                       <img
//                         src="/assets/images/logo.png"
//                         alt="MediStore"
//                         className="h-7 w-auto sm:h-8 md:h-10 drop-shadow-2xl"
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="hidden sm:flex flex-col leading-none">
//                   <h1 className="text-xl md:text-3xl font-black tracking-tight">
//                     <span className="text-white">Medi</span>
//                     <span className="text-red-500">Store</span>
//                   </h1>
//                   <span className="text-[10px] font-bold text-red-500 tracking-widest -mt-0.5 opacity-90">
//                     ONLINE PHARMACY
//                   </span>
//                 </div>
//               </Link>

//               {/* Desktop Search Bar */}
//               <div className="hidden lg:flex w-80 mx-6 relative">
//                 <div className="relative w-full">
//                   <select
//                     onChange={(e) => goToCategory(e.target.value)}
//                     className="absolute left-1 top-1/2 -translate-y-1/2 h-12 w-40 pl-4 pr-8 bg-gray-900 text-white rounded-l-full z-10 opacity-0 hover:opacity-100 transition-all duration-300 cursor-pointer font-medium border-r border-gray-700 text-sm"
//                   >
//                     {allCategories.map(cat => (
//                       <option key={cat} value={cat} className="bg-gray-900">{cat === 'All' ? 'All' : cat}</option>
//                     ))}
//                   </select>
//                   <input
//                     type="text"
//                     value={searchTerm}
//                     onChange={(e) => setSearchTerm(e.target.value)}
//                     onKeyPress={(e) => {
//                       if (e.key === 'Enter' && searchTerm.trim()) {
//                         navigate(`/search?q=${encodeURIComponent(searchTerm.trim())}`);
//                         setSearchTerm('');
//                         setShowSuggestions(false);
//                       }
//                     }}
//                     onFocus={() => searchTerm.trim() && setShowSuggestions(true)}
//                     placeholder="Search medicines..."
//                     className="w-full h-12 pl-44 pr-16 py-2 bg-white rounded-full text-gray-800 font-medium shadow-lg focus:outline-none focus:ring-2 focus:ring-red-500/40 transition-all duration-300 text-sm"
//                   />
//                   <button
//                     onClick={() => {
//                       if (searchTerm.trim()) {
//                         navigate(`/search?q=${encodeURIComponent(searchTerm.trim())}`);
//                         setSearchTerm('');
//                         setShowSuggestions(false);
//                       }
//                     }}
//                     className="absolute right-2 top-1/2 -translate-y-1/2 bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 h-9 w-12 rounded-full flex items-center justify-center shadow-lg hover:shadow-red-600/60 transition-all duration-300"
//                   >
//                     <i className="fas fa-search text-white text-base"></i>
//                   </button>
//                   <div className="absolute left-6 top-1/2 -translate-y-1/2 text-gray-500 font-medium pointer-events-none flex items-center gap-2 text-sm">
//                     All Categories <i className="fas fa-chevron-down text-xs"></i>
//                   </div>
//                 </div>

//                 {showSuggestions && suggestions.length > 0 && (
//                   <div
//                     className="absolute top-full mt-2 w-full bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden z-50"
//                     onClick={(e) => e.stopPropagation()}
//                   >
//                     {suggestions.map((product) => (
//                       <Link
//                         key={product.id}
//                         to={`/product/${product.id}`}
//                         onClick={() => {
//                           setSearchTerm('');
//                           setShowSuggestions(false);
//                         }}
//                         className="flex items-center gap-4 px-4 py-3 hover:bg-red-50 transition-all duration-200 border-b border-gray-100 last:border-0"
//                       >
//                         <div className="w-10 h-10 bg-gray-100 rounded-lg overflow-hidden border border-gray-300 shrink-0">
//                           <img src={`${API}${product.image_url}`} alt={product.name} className="w-full h-full object-cover" />
//                         </div>
//                         <div className="flex-1 min-w-0">
//                           <h4 className="font-semibold text-gray-800 text-sm truncate">{product.name}</h4>
//                           <div className="flex items-center gap-2 mt-1">
//                             <span className="text-lg font-bold text-red-600">
//                               {formatPrice(product.discountedPrice || product.price, currency)}
//                             </span>
//                             {product.discount && (
//                               <span className="text-xs text-gray-500 line-through ml-2">
//                                 {formatPrice(product.price, currency)}
//                               </span>
//                             )}
//                           </div>
//                         </div>
//                       </Link>
//                     ))}
//                   </div>
//                 )}
//               </div>

//               {/* Right Side Icons - Desktop */}
//               <div className="flex items-center gap-2 sm:gap-4 ml-auto flex-shrink-0 overflow-x-hidden">
//                 <Link
//                   to="/pharmacy"
//                   className={`group relative flex items-center gap-2 font-medium text-sm transition ${isActive("/pharmacy") ? "text-red-500" : "text-white hover:text-red-400"}`}
//                 >
//                   <span className="relative">
//                     Home
//                     {isActive("/pharmacy") && (
//                       <span className="absolute left-0 -bottom-1 w-full h-[2px] bg-red-500 rounded-full"></span>
//                     )}
//                   </span>
//                 </Link>

//                 <Link
//                   to="/wishlist"
//                   className={`relative p-2 rounded-lg transition-all flex items-center justify-center ${pathname === "/wishlist" ? "bg-red-900/40" : "hover:bg-red-900/30"}`}
//                 >
//                   <i className={`fas fa-heart text-lg transition ${pathname === "/wishlist" ? "text-red-500" : "text-white hover:text-red-500"}`}></i>
//                   {wishlistCount > 0 && (
//                     <span className="absolute -top-1 -right-1 bg-gradient-to-br from-red-500 to-pink-600 text-white text-[10px] font-bold rounded-full h-4 w-4 flex items-center justify-center shadow-lg">
//                       {wishlistCount}
//                     </span>
//                   )}
//                 </Link>

//                 <Link
//                   to="/cart"
//                   className={`relative p-2 rounded-lg transition-all flex items-center justify-center ${pathname === "/cart" ? "bg-red-900/40" : "hover:bg-red-900/30"}`}
//                 >
//                   <i className={`fas fa-shopping-cart text-lg transition ${pathname === "/cart" ? "text-red-500" : "text-white hover:text-red-500"}`}></i>
//                   {cartCount > 0 && (
//                     <span className="absolute -top-1 -right-1 bg-gradient-to-br from-red-500 to-pink-600 text-white text-[10px] font-bold rounded-full h-4 w-4 flex items-center justify-center shadow-lg">
//                       {cartCount}
//                     </span>
//                   )}
//                 </Link>

//                 {!isLoggedIn ? (
//                   <>
//                     <Link
//                       to="/contact"
//                       className={`group relative flex items-center gap-2 font-medium text-sm transition ${isActive("/contact") ? "text-red-500" : "text-white hover:text-red-400"}`}
//                     >
//                       <i className="fas fa-headset text-base"></i>
//                       <span className="relative">
//                         Contact Us
//                         {isActive("/contact") && (
//                           <span className="absolute left-0 -bottom-1 w-full h-[2px] bg-red-500 rounded-full"></span>
//                         )}
//                       </span>
//                     </Link>
//                     <Link
//                       to="/auth?tab=register"
//                       className="bg-gradient-to-r from-red-600 to-red-700 px-4 py-2 rounded-lg font-bold text-white text-sm"
//                     >
//                       Sign Up
//                     </Link>
//                   </>
//                 ) : (
//                   <>
//                     <Link
//                       to="/contact"
//                       className={`group relative flex items-center gap-2 font-medium text-sm transition ${isActive("/contact") ? "text-red-500" : "text-white hover:text-red-400"}`}
//                     >
//                       <i className="fas fa-headset text-base"></i>
//                       <span className="relative">
//                         Contact
//                         {isActive("/contact") && (
//                           <span className="absolute left-0 -bottom-1 w-full h-[2px] bg-red-500 rounded-full"></span>
//                         )}
//                       </span>
//                     </Link>
//                     <Link
//                       to="/orders"
//                       className={`group relative flex items-center gap-2 font-medium text-sm transition ${isActive("/orders") ? "text-red-500" : "text-white hover:text-red-400"}`}
//                     >
//                       <i className="fas fa-history text-base"></i>
//                       <span className="relative">
//                         Orders
//                         {isActive("/orders") && (
//                           <span className="absolute left-0 -bottom-1 w-full h-[2px] bg-red-500 rounded-full"></span>
//                         )}
//                       </span>
//                     </Link>
//                     <button
//                       onClick={() => setDrawerOpen(true)}
//                       className="w-9 h-9 rounded-full bg-gradient-to-br from-red-600 to-red-700 text-white font-bold text-lg flex items-center justify-center shadow-lg"
//                     >
//                       {user?.name?.charAt(0).toUpperCase() || "U"}
//                     </button>
//                   </>
//                 )}
//               </div>
//             </div>

//           </div>

//           {/* ================= MOBILE MENU (with Search) ================= */}
//           {mobileMenuOpen && (
//             <div className="lg:hidden pb-6 pt-3 animate-fadeIn bg-black/95 border-t border-red-900/30">
//               {/* Search Bar at Top */}
//               <div className="px-4 mb-5">
//                 <div className="relative">
//                   <input
//                     type="text"
//                     value={searchTerm}
//                     onChange={(e) => setSearchTerm(e.target.value)}
//                     onKeyDown={(e) => {
//                       if (e.key === "Enter" && searchTerm.trim()) {
//                         navigate(`/search?q=${encodeURIComponent(searchTerm.trim())}`);
//                         setSearchTerm("");
//                         setMobileMenuOpen(false);
//                       }
//                     }}
//                     placeholder="Search medicines..."
//                     className="w-full h-11 pl-10 pr-4 bg-gray-800 text-white rounded-xl text-base border border-red-600/30 focus:border-red-500 focus:outline-none"
//                   />
//                   <i className="fas fa-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
//                 </div>
//               </div>

//               {/* Menu Links */}
//               <div className="space-y-1 px-2">
//                 <Link to="/marketplace" onClick={() => setMobileMenuOpen(false)} className="block px-4 py-3 text-white hover:bg-red-900/30 rounded-lg flex items-center">
//                   <i className="fas fa-home mr-3 text-red-500"></i> Home
//                 </Link>
//                 <Link to="/cart" onClick={() => setMobileMenuOpen(false)} className="block px-4 py-3 text-white hover:bg-red-900/30 rounded-lg flex items-center">
//                   <i className="fas fa-shopping-cart mr-3 text-red-500"></i> My Cart ({cartCount})
//                 </Link>
//                 <Link to="/wishlist" onClick={() => setMobileMenuOpen(false)} className="block px-4 py-3 text-white hover:bg-red-900/30 rounded-lg flex items-center">
//                   <i className="fas fa-heart mr-3 text-red-500"></i> Wishlist ({wishlistCount})
//                 </Link>
//                 {isLoggedIn && (
//                   <Link to="/orders" onClick={() => setMobileMenuOpen(false)} className="block px-4 py-3 text-white hover:bg-red-900/30 rounded-lg flex items-center">
//                     <i className="fas fa-history mr-3 text-red-500"></i> Order History
//                   </Link>
//                 )}
//                 <Link to="/contact" onClick={() => setMobileMenuOpen(false)} className="block px-4 py-3 text-white hover:bg-red-900/30 rounded-lg flex items-center">
//                   <i className="fas fa-headset mr-3 text-red-500"></i> Contact Us
//                 </Link>
//               </div>
//             </div>
//           )}
//         </div>
//       </nav>

//       {/* ================= ACCOUNT DRAWER ================= */}
//      {/* Overlay */}
// <div
//   className={`fixed inset-0 backdrop-blur-sm bg-black/50 z-40 transition-opacity duration-300 ${
//     drawerOpen ? "opacity-100 visible" : "opacity-0 invisible"
//   }`}
//   onClick={() => setDrawerOpen(false)}
// />

// {/* Drawer */}
// <div
//   className={`fixed top-0 right-0 h-full w-80 bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900 
//   shadow-[0_0_40px_rgba(0,0,0,0.6)] z-50 transform transition-all duration-300 ease-in-out
//   ${drawerOpen ? "translate-x-0 opacity-100" : "translate-x-full opacity-0"}`}
// >
//   {/* Header */}
//   <div className="p-6 border-b border-gray-700 flex justify-between items-center">
//     <h3 className="text-2xl font-semibold text-white tracking-wide">
//       My Account
//     </h3>

//     <button
//       onClick={() => setDrawerOpen(false)}
//       className="w-9 h-9 flex items-center justify-center rounded-full 
//       bg-gray-800 hover:bg-red-500/20 text-gray-400 hover:text-red-500 
//       transition-all duration-300"
//     >
//       <i className="fas fa-times text-lg"></i>
//     </button>
//   </div>

//   {/* Menu Items */}
//   <ul className="p-6 space-y-3">
//     <li>
//       <Link
//         to="/profile"
//         onClick={() => setDrawerOpen(false)}
//         className="flex items-center gap-4 px-4 py-3 rounded-xl 
//         bg-gray-800/60 hover:bg-red-500/10 
//         text-gray-300 hover:text-red-400 
//         transition-all duration-300 group"
//       >
//         <i className="fas fa-user text-lg group-hover:scale-110 transition-transform"></i>
//         <span className="text-base font-medium">My Profile</span>
//       </Link>
//     </li>

//     <li>
//       <button
//         onClick={onLogoutClick}
//         className="flex items-center gap-4 px-4 py-3 rounded-xl w-full text-left
//         bg-gray-800/60 hover:bg-red-500/10 
//         text-gray-300 hover:text-red-400 
//         transition-all duration-300 group"
//       >
//         <i className="fas fa-sign-out-alt text-lg group-hover:scale-110 transition-transform"></i>
//         <span className="text-base font-medium">Logout</span>
//       </button>
//     </li>
//   </ul>
// </div>
//     </>
//   );
// };

// export default Header;
import React, { useState, useEffect } from "react";
import { Link,useNavigate , NavLink} from "react-router-dom";
import { FiMenu, FiX, FiSearch, FiShoppingCart, FiHeart } from "react-icons/fi";
import { motion } from "framer-motion";
import { useAuth } from "../../context/authContext";   // ← Import this
import { RxAvatar } from "react-icons/rx";
const DOMAIN_TABLES = ["Education", "Food", "Pharmacy", "Toys", "Devices"];
const API = process.env.REACT_APP_API_URL;

const fadeInUp = {
  hidden: { opacity: 0, y: 70 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, ease: 'easeOut' }
  }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.18, delayChildren: 0.2 }
  }
};

const navLinkVariants = {
  rest: { y: 0 },
  hover: { y: -2, transition: { duration: 0.3, type: 'spring', stiffness: 400 } }
};

function Header() {
  const { isLoggedIn, user, handleLogout } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeDomain, setActiveDomain] = useState(null);
  const [profileDrawerOpen, setProfileDrawerOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [categories, setCategories] = useState({});

  const [cartCount, setCartCount] = useState(0);
  const [wishlistCount, setWishlistCount] = useState(0);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(false);
const [suggestions, setSuggestions] = useState([]);
const { products, cart, wishlist, fetchCart, fetchWishlist } = useAuth(); 
// Search Logic
useEffect(() => {
  if (!searchTerm.trim()) {
    setSuggestions([]);
    setShowSuggestions(false);
    return;
  }

  // Filter products by name or category
  const filtered = products
    .filter(product =>
      product.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.category?.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .slice(0, 8);

  setSuggestions(filtered);
  setShowSuggestions(true);
}, [searchTerm, products]);
// Badge Logic
useEffect(() => {
  setCartCount(cart?.length || 0);
  setWishlistCount(wishlist?.length || 0);
}, [cart, wishlist]);

// Close suggestions when clicking outside
useEffect(() => {
  const handleClickOutside = (e) => {
    if (!e.target.closest('.relative')) {
      setShowSuggestions(false);
    }
  };
  document.addEventListener('click', handleClickOutside);
  return () => document.removeEventListener('click', handleClickOutside);
}, []);

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      alert(`Searching for "${searchTerm}"`);
    }
  };
  const handleLogoutClick = () => {
    handleLogout();
    setProfileDrawerOpen(false);
  };
  const toggleDomain = async (domain) => {
    if (activeDomain === domain) {
      setActiveDomain(null);
      return;
    }

    setActiveDomain(domain);

    // Fetch categories only if not already loaded
    if (!categories[domain]) {
      try {
        const res = await fetch(`${API}/api/categories?domain=${domain}`);
        const data = await res.json();
        setCategories((prev) => ({
          ...prev,
          [domain]: data,
        }));
      } catch (err) {
        console.error("Error fetching categories:", err);
      }
    }
  };

  const navItems = [
    {name : 'Home', path: '/', isExternal: false},
    { name: 'Orders', path: '/orders', isExternal: false },
    { name: 'Contact Us', path: '/contact', isExternal: false },
    // { name: 'Sign Up', path: '/auth?tab=register', isExternal: false },
  ];
// Load categories for ALL domains when component mounts
useEffect(() => {
  const loadAllCategories = async () => {
    const newCategories = {};
    
    for (const domain of DOMAIN_TABLES) {
      try {
        const res = await fetch(`${API}/api/categories?domain=${domain}`);
        if (res.ok) {
          const data = await res.json();
          newCategories[domain] = data;
        }
      } catch (err) {
        console.error(`Failed to load categories for ${domain}:`, err);
        newCategories[domain] = []; // fallback
      }
    }
    
    setCategories(newCategories);
  };

  loadAllCategories();
}, []);
  return (
    <div className="min-h-[50px] text-white font-sans">
           {/* Modern Compact Navbar */}
      <motion.header
  initial={{ y: -100, opacity: 0 }}
  animate={{ y: 0, opacity: 1 }}
  transition={{ duration: 0.8, ease: 'easeOut' }}
  className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-xl border-b border-gray-800"
>
  <nav className="max-w-7xl mx-auto px-6">
    <div className="flex items-center justify-between">
     
      {/* Logo + All Button + Search */}
      <div className="flex items-center gap-6 flex-1">
        <motion.div
          className="text-3xl font-bold tracking-tighter cursor-pointer"
          whileHover={{ scale: 1.05 }}
          onClick={() => window.location.href = '/'}
        >
          <span className="text-red-600 mr-20">Amaravatee</span>
        </motion.div>

        {/* All Categories Dropdown - Click + Hover */}
{/* All Categories Dropdown */}
<div className="relative hidden md:block">
  <button
    onClick={() => setDropdownOpen(!dropdownOpen)}
    className="flex items-center gap-2 px-4 py-2.5 bg-gray-900 hover:bg-gray-800 border border-gray-700 hover:border-red-600 rounded-2xl text-sm font-medium text-white transition-all active:scale-95"
  >
    <span>All</span>
    <span className={`text-xs transition-transform duration-300 ${dropdownOpen ? 'rotate-180' : ''}`}>
      ▼
    </span>
  </button>

  {/* Top Dropdown Menu - 5 Domains in One Row */}
  {dropdownOpen && (
  <div className="absolute left-0 top-full mt-2 w-[920px] max-w-[92vw] bg-gray-950 border border-gray-700 rounded-2xl shadow-2xl z-[60] overflow-hidden">
    
    <div className="p-6"> {/* Reduced padding */}
      <div className="grid grid-cols-5 gap-x-6 gap-y-8"> {/* Tighter gaps */}
        {DOMAIN_TABLES.map((domain) => {
          const domainCats = categories[domain] || [];
          const displayCats = domainCats.slice(0, 5);
          const hasMore = domainCats.length > 5;

          return (
            <div key={domain} className="space-y-2"> {/* Reduced spacing */}
              {/* Domain Title - Smaller & Clean */}
              <Link
                to={`/${domain.toLowerCase()}`}
                className="block group"
                onClick={() => setDropdownOpen(false)}
              >
                <h3 className="font-semibold text-red-500 text-[18px] tracking-wide border-b border-gray-800 pb-1.5 mx-2">
                {domain}
              </h3>
              </Link>
              {/* Categories - Even Smaller & Compact */}
              <ul className="space-y-0.5 text-sm min-h-[140px]">
  {displayCats.length > 0 ? (
    displayCats.map((cat) => {
      const slug = cat.toLowerCase().replace(/\s+/g, "-");
      return (
        <li key={cat}>
          <Link
            to={`/${domain.toLowerCase()}?category=${slug}`}
            className="block py-1 -mx-4 text-gray-400 hover:text-white hover:bg-gray-900 rounded-lg transition-all text-[14px] leading-tight"
            onClick={() => setDropdownOpen(false)}
          >
            {cat}
          </Link>
        </li>
      );
    })
  ) : (
    <li className="text-gray-500 text-xs py-1">Loading...</li>
  )}
</ul>

              {hasMore && (
                <Link
                  to={`/${domain.toLowerCase()}`}
                  className="inline-block text-red-500 hover:text-red-400 text-[12px] font-medium mt-1 transition-colors"
                  onClick={() => setDropdownOpen(false)}
                >
                  View more →
                </Link>
              )}
            </div>
          );
        })}
      </div>
    </div>

    {/* Simple Footer - Only Small Close Button */}
    <div className="border-t border-gray-800 px-6 py-3 bg-gray-900/70 flex justify-end">
      <button
        onClick={() => setDropdownOpen(false)}
        className=" hover:text-red-400 text-xs font-medium px-2.5 py-1.5 rounded-xl hover:bg-gray-800 transition-all flex items-center gap-1"
      >
        Close 
      </button>
    </div>
  </div>
)}
</div>

        {/* Search Bar */}
        {/* Improved Search Bar */}
<div className="relative flex-1 max-w-xl hidden md:block">
  <input
    type="text"
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
    onKeyDown={(e) => {
      if (e.key === 'Enter' && searchTerm.trim()) {
        navigate(`/search?q=${encodeURIComponent(searchTerm.trim())}`);
        setSearchTerm('');
      }
    }}
    onFocus={() => setShowSuggestions(true)}
    placeholder={
      window.location.pathname.includes('/pharmacy') 
        ? "Search in Pharmacy..." 
        : "Search everything..."
    }
    className="w-full bg-gray-900 border border-gray-700 focus:border-red-600 focus:ring-1 focus:ring-red-600 rounded-2xl py-2.5 px-5 pl-11 text-sm text-white placeholder-gray-400 transition-all"
  />
  <FiSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-lg" />

  {/* Search Suggestions */}
  {showSuggestions && searchTerm.trim() && suggestions.length > 0 && (
    <div className="absolute top-full mt-2 w-full bg-gray-900 border border-gray-700 rounded-2xl shadow-2xl z-[70] overflow-hidden max-h-80 overflow-y-auto">
      {suggestions.map((product) => (
        <Link
          key={product.id || product.product_id}
          to={`/product/${product.domain || 'medical'}/${product.id || product.product_id}`}
          onClick={() => {
            setSearchTerm('');
            setShowSuggestions(false);
          }}
          className="flex items-center gap-4 px-5 py-3.5 hover:bg-gray-800 border-b border-gray-800 last:border-0 transition-all"
        >
          <div className="w-10 h-10 bg-gray-800 rounded-lg overflow-hidden flex-shrink-0">
            {product.image_url && (
              <img 
                src={`${API}${product.image_url}`} 
                alt={product.name} 
                className="w-full h-full object-cover" 
              />
            )}
          </div>
          <div className="flex-1 min-w-0">
            <h4 className="text-white text-sm font-medium truncate">{product.name}</h4>
            <p className="text-gray-400 text-xs mt-0.5">{product.category}</p>
          </div>
          {product.price && (
            <span className="text-red-500 font-medium text-sm">₹{product.price}</span>
          )}
        </Link>
      ))}
    </div>
  )}
</div>
      </div>

      {/* Right Side Navigation */}
      <div className="flex items-center gap-5">
        <ul className="hidden lg:flex items-center gap-6 xl:gap-8 text-lg font-semibold tracking-wide mt-3">
           {navItems.map((item) => (
    <motion.li
      key={item.name}
      variants={navLinkVariants}
      initial="rest"
      whileHover="hover"
      className="relative"
    >
      <NavLink
        to={item.path}
        className={({ isActive }) =>
          `relative transition-all duration-300 text-[16px] ${
            isActive
              ? "text-red-500 after:w-full"
              : "text-white hover:text-red-500"
          } after:content-[''] after:absolute after:h-0.5 after:bg-red-600 after:left-0 after:bottom-[-6px] after:transition-all after:duration-300 ${
            isActive ? "after:w-full" : "after:w-0 hover:after:w-full"
          }`
        }
      >
        {item.name}
      </NavLink>
    </motion.li>
  ))}
  <motion.li className="relative">
  <NavLink to="/wishlist">
    {({ isActive }) => (
      <div className="relative">
        <FiHeart
          className={`text-2xl transition-colors duration-300 ${
            isActive
              ? "text-red-500"
              : "text-white hover:text-red-500"
          }`}
        />

        {wishlistCount > 0 && (
          <span className="absolute -top-2 -right-2 bg-red-600 text-white text-xs w-5 h-5 flex items-center justify-center rounded-full">
            {wishlistCount}
          </span>
        )}
      </div>
    )}
  </NavLink>
</motion.li>

<motion.li className="relative">
  <NavLink to="/cart">
    {({ isActive }) => (
      <div className="relative">
        <FiShoppingCart
          className={`text-2xl transition-colors duration-300 ${
            isActive
              ? "text-red-500"
              : "text-white hover:text-red-500"
          }`}
        />

        {cartCount > 0 && (
          <span className="absolute -top-2 -right-2 bg-red-600 text-white text-xs w-5 h-5 flex items-center justify-center rounded-full">
            {cartCount}
          </span>
        )}
      </div>
    )}
  </NavLink>
</motion.li>
          {isLoggedIn ? (
                  <button
                    onClick={() => setProfileDrawerOpen(true)}
                    className="overflow-hidden border-2 border-gray-400 hover:border-red-600 transition-all flex items-center justify-center bg-gray-800
                    py-1 px-3 bg-transparent rounded-full" 
                  >
                    {user?.name ? (
                      <span className="text-white font-medium text-lg ">
                        {user.name.charAt(0).toUpperCase()}
                      </span>
                      
                    ) : (
                      <RxAvatar size={24} className="text-gray-300" />
                    )}
                  </button>
                ) : (
                  <Link
                    to="/auth?tab=register"
                    className="bg-red-600 hover:bg-red-700 px-6 py-2.5 rounded-2xl text-sm font-medium transition-all text-white"
                  >
                    Sign Up
                  </Link>
                )}
        </ul>

        {/* Mobile Hamburger */}
        <button
          onClick={() => setSidebarOpen(true)}
          className="lg:hidden text-2xl p-1 text-white"
        >
          <FiMenu />
        </button>
      </div>
    </div>
  </nav>
</motion.header>
{profileDrawerOpen && (
        <div
          className="fixed inset-0 bg-black/70 z-[70]"
          onClick={() => setProfileDrawerOpen(false)}
        />
      )}

      {/* Drawer */}
      <div
        className={`fixed top-0 right-0 h-full w-72 bg-gray-950 border-l border-gray-800 shadow-2xl z-[80] transform transition-transform duration-300 ${
          profileDrawerOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="p-6 border-b border-gray-800 flex items-center justify-between">
          <h3 className="text-lg font-medium text-white">Hello, {user?.name || "Guest"}</h3>
          <button
            onClick={() => setProfileDrawerOpen(false)}
            className="text-gray-400 hover:text-white  p-2 bg-transparent"
          >
            <FiX size={22}/>
          </button>
        </div>

        <div className="p-4">
          <Link
            to="/profile"
            onClick={() => setProfileDrawerOpen(false)}
            className="flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-gray-900 text-gray-300 hover:text-red-400 transition-all"
          >
            <RxAvatar size={24} />
            <span className="font-medium">My Profile</span>
          </Link>

          <button
            onClick={handleLogoutClick}
            className="flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-gray-900 text-gray-400 hover:text-red-400 w-full text-left transition-all bg-transparent "
          >
            <FiX size={24} className="rotate-45" />
            <span className="font-medium">Logout</span>
          </button>
        </div>
      </div>
      {/* Improved Modern Sidebar */}
      <div
        className={`fixed top-0 left-0 h-full w-72 bg-gray-950 border-r border-gray-800 shadow-2xl z-[60] transform transition-transform duration-300 overflow-hidden ${
          sidebarOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        {/* Sidebar Header */}
        <div className="px-6 py-5 border-b border-gray-800 flex items-center justify-between bg-gray-950 sticky top-0 z-10">
          <h2 className="text-xl font-semibold text-white">All Categories</h2>
          <button
            onClick={() => setSidebarOpen(false)}
            className="text-gray-400 hover:text-white text-2xl transition-colors"
          >
            <FiX />
          </button>
        </div>

        {/* Sidebar Content */}
        <div className="overflow-y-auto h-[calc(100vh-73px)] px-3 py-4">
          {DOMAIN_TABLES.map((domain) => (
            <div key={domain} className="mb-1">
              {/* Domain Button - No Red Background */}
              {/* Domain Item */}
              <div className="flex items-center justify-between w-full px-5 py-3 font-medium text-white rounded-2xl hover:bg-gray-900 transition-all group">
                <Link
                  to={`/${domain.toLowerCase()}`}
                  onClick={() => setSidebarOpen(false)}
                  className="flex-1 text-left group-hover:text-red-500 transition-colors"
                >
                  {domain}
                </Link>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    toggleDomain(domain);
                  }}
                  className="pl-4 pr-2 text-xl text-gray-400 group-hover:text-red-500 transition-colors"
                >
                  {activeDomain === domain ? "−" : "+"}
                </button>
              </div>

              {/* Subcategories */}
              {activeDomain === domain && categories[domain] && (
                <div className="ml-6 mt-1 mb-4 border-l border-gray-800 pl-5">
                  <ul className="space-y-0.5">
                    {categories[domain].map((cat) => (
                      <li key={cat}>
                        <Link
                          to={`/${domain.toLowerCase()}?category=${cat.toLowerCase().replace(/\s+/g, "-")}`}
                          className="block px-4 py-2.5 text-sm text-gray-300 hover:text-red-500 hover:bg-gray-900 rounded-xl transition-all"
                          onClick={() => setSidebarOpen(false)}
                        >
                          {cat}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/70 z-50"
          onClick={() => setSidebarOpen(false)}
        />
      )}
      </div>
  );
}
export default Header;